import { useCallback as e } from "react";
import { a as o } from "../events-CwIlKnwM.mjs";
function f(r) {
  return e((a) => o(r)(a), [r]);
}
export {
  f as default
};
